import React from 'react';
import { Helmet } from 'react-helmet';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { legacyTheme } from '../themes/legacyTheme';
import SEO, { MetadataItem } from './Seo';
import Navbar from './Navbar';
import Footer from './Footer';

export interface LayoutProps {
  title?: string;
  description?: string;
  isNavInitiallyWhite?: boolean;
  isNavInitiallyTransparent?: boolean;
  additionalMetadata?: MetadataItem[];
  noIndex?: boolean;
  children: React.ReactNode;
}

const Layout = ({
  title = '',
  description = '',
  noIndex = false,
  isNavInitiallyWhite = false,
  isNavInitiallyTransparent = true,
  additionalMetadata = [],
  children,
}: LayoutProps) => (
  <ChakraProvider theme={legacyTheme}>
    <Box w="100%">
      <SEO
        title={title}
        description={description}
        additionalMetadata={additionalMetadata}
        noIndex={noIndex}
      />
      <Navbar
        isNavInitiallyWhite={isNavInitiallyWhite}
        isNavInitiallyTransparent={isNavInitiallyTransparent}
      />
      {children}
      <Footer />
    </Box>
  </ChakraProvider>
);
Layout.defaultProps = {
  title: '',
  description: '',
  isNavInitiallyWhite: false,
  isNavInitiallyTransparent: true,
  additionalMetadata: [],
  noIndex: false,
};

export default Layout;
